"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheWanderlustPhilosophy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223212" id="the-wanderlust-philosophy" className="dark bg-background text-foreground w-full p-6 lg:p-[10%] overflow-hidden">
            <div ref={ref} className={`flex flex-col lg:flex-row w-full min-h-[80vh] shadow-2xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                {}
                <div className="w-full lg:w-1/2 relative min-h-[50vh] lg:min-h-0 bg-secondary">
                    <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687046/img/mountain_climber_summit_grain.png" alt="High-contrast mountain climber reaching the peak" className="absolute inset-0 w-full h-full object-cover grayscale contrast-125" />
                    <div className="absolute inset-0 bg-primary/20 mix-blend-multiply" />
                </div>

                {}
                <div className="w-full lg:w-1/2 bg-background text-foreground flex flex-col justify-center p-10 lg:p-20 xl:p-24 border-l border-white/5">
                    <div className="max-w-xl">
                        <span className="font-mono text-sm tracking-widest uppercase mb-8 block text-primary">
                            01 
                        </span>
                        <h2 className="font-default text-5xl lg:text-6xl xl:text-7xl font-bold mb-8 leading-[1.1] tracking-tighter text-chart-2 uppercase">
                            The Wanderlust Philosophy
                        </h2>
                        <div className="space-y-6 mb-12">
                            <p className="font-default text-xl lg:text-2xl leading-relaxed opacity-90 text-foreground">
                                We believe that travel is more than just visiting a destination; it is a transformative pursuit of the unknown. Our expeditions are crafted for those who seek the raw, the rugged, and the remarkable.
                            </p>
                            <p className="font-default text-xl lg:text-2xl leading-relaxed opacity-90 text-foreground">
                                By bridging the gap between luxury and adventure, we provide access to the world's most remote corners without compromising on the sophistication of the journey.
                            </p>
                            <p className="font-default text-xl lg:text-2xl leading-relaxed opacity-90 text-foreground">
                                Every itinerary is a curated narrative, designed to challenge your limits and expand your perspective through authentic cultural immersion and breathtaking natural wonders.
                            </p>
                        </div>
                        <Link to="/ExpeditionsPage" className="group inline-flex items-center gap-4 font-mono text-sm tracking-widest uppercase transition-all hover:text-primary">
                            <span className="border-b border-primary pb-1">Explore Expeditions</span>
                            <ArrowRight className="w-5 h-5 text-primary transition-transform duration-300 group-hover:translate-x-2" />
                        </Link>
                    </div>
                </div>
            </div>
        </section>;
}